import SimpleCard from 'components/SimpleCard'
import Main from 'layouts/main'
import React, { useState } from 'react'
import KanbanComponent from 'components/KanbanComponent'
import { SimpleTitleCard } from 'styles/global'
import { BsKanban } from 'react-icons/bs'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { KANBAN } from 'store/modules/kanban/types'
import TabKanban from './components/Tab/TabKanban'
import { TabItem } from './components/Tab/TabsMenu'
import { MdOutlineDashboard } from 'react-icons/md'
import { TbLayoutKanban } from 'react-icons/tb'
import { FiUsers } from 'react-icons/fi'

const Kanban = () => {
  const { kanbanData } = useSelector<ApplicationState, KANBAN>(
    (state) => state.kanban
  )
  const [value, setValue] = useState(1)

  const tabs: TabItem[] = [
    {
      label: 'Dashboard',
      icon: <MdOutlineDashboard size={18} />,
      content: 'Conteúdo do Dashboard'
    },
    {
      label: 'Kanban',
      icon: <TbLayoutKanban size={18} />,
      content: <KanbanComponent data={kanbanData} />
    },
    {
      label: 'Contatos',
      icon: <FiUsers size={18} />,
      content: 'Conteúdo de Contatos'
    }
  ]

  return (
    <Main>
      <SimpleCard>
        <SimpleTitleCard>
          <BsKanban className="icon" />
          Kanban
        </SimpleTitleCard>
        <TabKanban
          value={value}
          onChange={(_, newValue) => {
            setValue(newValue)
          }}
          tabs={tabs}
        />
      </SimpleCard>
    </Main>
  )
}

export default Kanban
